import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { Any } from 'json2typescript';

@JsonObject('model.project.customfield')
export class CustomField extends AbstractModel {

    // @JsonProperty(Any, 'booleanValue')
    // booleanValue?: any;

    @JsonProperty(DateConverter, 'dateValue')
    dateValue?: Date;

    @JsonProperty(String, 'definitionId')
    definitionId?: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'numberValue')
    numberValue?: string;

    @JsonProperty(String, 'stringValue')
    stringValue?: string;

    @JsonProperty(String, 'type')
    type?: string;
}
